/* sk8 Monster Drops, tema 360: avaliações (snippets/sk8-avaliacoes.liquid).
   "Ver mais" mostra as avaliações escondidas; tocar numa foto abre a foto grande
   num <dialog> (Esc, o botão "Fechar" ou o toque fora fecham). */
(function () {
  "use strict";
  document.querySelectorAll("[data-avaliacoes]").forEach(function (bloco) {
    var mais = bloco.querySelector("[data-avaliacoes-mais]");
    if (mais) mais.addEventListener("click", function () {
      bloco.querySelectorAll("[data-avaliacao-extra]").forEach(function (li) { li.hidden = false; });
      mais.hidden = true;
      mais.setAttribute("aria-expanded", "true");
    });
    var caixa = bloco.querySelector("[data-avaliacoes-ampliada]"), img = bloco.querySelector("[data-avaliacoes-img]");
    if (!caixa || !img) return;
    bloco.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-foto-grande]");
      if (!b) return;
      img.src = b.getAttribute("data-foto-grande");
      if (typeof caixa.showModal === "function") caixa.showModal();
      else window.open(img.src, "_blank", "noopener");
    });
    var fechar = bloco.querySelector("[data-avaliacoes-fechar]");
    if (fechar) fechar.addEventListener("click", function () { caixa.close(); });
    caixa.addEventListener("click", function (e) { if (e.target === caixa) caixa.close(); });
  });
})();
